export const Loader = () => {
    return (
        <div className="loader-container">
            <div className="home-slide-cover mt-30 text-dark">Loading...</div>
        </div>
    );
};
